import { memo, use, useState } from 'react'

import { Link } from 'react-router-dom'
import {
  Avatar,
  Menu,
  MenuButton,
  MenuItem,
  MenuItemProps,
  MenuList,
  Spinner,
  Text,
  useDisclosure,
} from '@chakra-ui/react'

import api from '@/api'
import { HeaderContext } from '@/context/Header'
import { useIsAdmin, useTeam } from '@/react-query/team'
import { useSignOut, useUser } from '@/react-query/user'

const ProfileDropDown = memo(() => {
  const user = useUser()
  const signOut = useSignOut()

  const [isPortalLoading, setIsPortalLoading] = useState<boolean>(false)
  const { isOpen, onOpen, onClose } = useDisclosure()

  const { referralModalDisclosure } = use(HeaderContext)

  const isTeamAdmin = useIsAdmin()

  const handleOpenPortal: MenuItemProps['onClick'] = async (e) => {
    try {
      e.preventDefault()

      setIsPortalLoading(true)

      const { portalSessionUrl } = (await api.createPortalSession()).data

      window.location.href = portalSessionUrl
    } catch (error) {
      console.error(error)
      setIsPortalLoading(false)
    }
  }

  const team = useTeam()

  return (
    <div className="flex items-center">
      <div className="mr-2 text-right hidden md:block">
        <Text fontWeight={'bold'}>{user.data?.displayName || ''}</Text>
        {team.data?.name && (
          <Text fontSize={'sm'} color={'gray.500'} fontWeight={'500'}>
            team {team.data.name}
          </Text>
        )}
      </div>
      <Menu
        placement={'bottom-end'}
        isOpen={isOpen}
        onClose={onClose}
        closeOnSelect={false}
      >
        <MenuButton onClick={onOpen}>
          <Avatar
            h={'2.5rem'}
            w={'2.5rem'}
            name={user.data?.displayName || 'AA'}
            src={user.data?.photoURL || ''}
          />
        </MenuButton>
        <MenuList
          overflow={'hidden'}
          rounded={'1.25rem'}
          bg={'white'}
          minWidth={'12.75rem'}
        >
          {(!team.data?.userRole || isTeamAdmin) && (
            <MenuItem
              bg={'white'}
              py={2.5}
              _hover={{
                bg: '#f6f6f6',
              }}
              justifyContent={'flex-end'}
              onClick={handleOpenPortal}
            >
              {isPortalLoading ? (
                <div className="flex w-full justify-center">
                  <Spinner />
                </div>
              ) : (
                'Manage subscription'
              )}
            </MenuItem>
          )}

          <MenuItem
            bg={'white'}
            py={2.5}
            _hover={{
              bg: '#f6f6f6',
            }}
            justifyContent={'flex-end'}
            onClick={(event) => {
              event.preventDefault()
              referralModalDisclosure.onOpen()
            }}
          >
            Refer a friend
          </MenuItem>
          <MenuItem
            as={Link}
            to="/team"
            bg="white"
            py={2.5}
            _hover={{ bg: '#f6f6f6' }}
            justifyContent="flex-end"
            onClick={onClose}
          >
            Team Settings
          </MenuItem>
          <MenuItem
            as={Link}
            to="/settings"
            bg="white"
            py={2.5}
            _hover={{ bg: '#f6f6f6' }}
            justifyContent="flex-end"
            onClick={onClose}
          >
            Settings
          </MenuItem>
          <MenuItem
            bg={'white'}
            py={2.5}
            _hover={{
              bg: '#f6f6f6',
            }}
            justifyContent={'flex-end'}
            onClick={(event) => {
              event.preventDefault()
              signOut.mutateAsync().catch(console.error)
            }}
          >
            Sign Out
          </MenuItem>
        </MenuList>
      </Menu>
    </div>
  )
})

export default ProfileDropDown
